import { useAssetContext } from "../../../shared/context/assetContext"
import { Box, TextField, Tooltip, IconButton, LinearProgress, Typography, Avatar } from "@mui/material"
import { Refresh as RefreshIcon, Add as AddIcon, Category as CategoryIcon } from '@mui/icons-material'
import { useEffect } from "react"
import equipmentIcon from '../../../assets/box-equipment.png'
import locationIcon from '../../../assets/ubicacion.png'
import { useTheme } from '@mui/material/styles'
import { useUtiles } from '../../../shared/context/utilesContext'
import { useTaskContext } from '../../../shared/context/taskContext'


export default function SelectAssetComponent( { functionSelect=null }) {
    const { assets, loadingAssets, getAssets } = useAssetContext()
    const { task, setTask } = useTaskContext()
    const { locationString, toogleOpenSilder } = useUtiles()
    const theme = useTheme()

    const handleSearch = (e) => {
        getAssets({ name_code: e.target.value })
    }

    const handleSelectAsset = (asset) => {
        if (functionSelect) {
            functionSelect(asset)
        } else {
            setTask({...task, asset: asset})
        }
        toogleOpenSilder(null, 0, null)
    }

    useEffect(() => {
        getAssets()
    }, [])

 

    return (
        <Box sx={{ padding: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <TextField fullWidth placeholder="Escribe para buscar" size="small" onChange={handleSearch} />
                <Tooltip title="Refrescar">
                    <IconButton size="small" onClick={() => getAssets()}>
                        <RefreshIcon />
                    </IconButton>
                </Tooltip>
            </Box>

            {loadingAssets && <LinearProgress sx={{ mt: 2 }} />}

            <Box sx={{ maxHeight: 750, overflow: 'auto' }}>
                {assets.map((asset) => (
                    <Box
                        key={asset.id}
                        onClick={() => handleSelectAsset(asset)}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 2,
                            p: 1.5,
                            my: 1,
                            borderRadius: 1,
                            boxShadow: '0 1px 3px rgba(0,0,0,0.12)',
                            transition: 'all 0.2s ease',
                            '&:hover': {
                                backgroundColor: 'rgba(0,0,0,0.04)',
                                transform: 'translateY(-2px)',
                                boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
                            },
                            cursor: 'pointer',
                        }}
                    >
                        <Avatar sx={{ width: 30, height: 30, backgroundColor: "#4f47e6" }}>
                            {asset.type === 'equipment' ? (
                                <img src={equipmentIcon} alt="Equipo" style={{ width: 24, height: 24 }} />
                            ) : (
                                <img src={locationIcon} alt="Ubicación" style={{ width: 24, height: 24 }} />
                            )}
                        </Avatar>
                        <Box>
                            <Typography fontWeight="medium">{asset.name}</Typography>
                            <Typography fontWeight="medium" sx={{ fontSize: '11px', color: theme.palette.text.secondary }}>{locationString(asset.parent)}</Typography>
                        </Box>
                        {asset.code && (
                            <Typography variant="caption" color="text.secondary" sx={{ ml: 'auto' }}>
                                {asset.code}
                            </Typography>
                        )}
                    </Box>
                ))}
            </Box>
        </Box>
    )
}